import {Avatar, Box, Button, Stack, Typography} from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import {useNavigate} from 'react-router-dom';
import axios from '../../axios';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import InformationBox from '../profile/InformationBox';
import {useRole} from '../userInfo/hooks/useRole';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';
import {formatPhoneNumber} from "../Service";

const ViewProfile = ({setUpdateMode}) => {
  const {profil} = useUserInfo();
  const {mode} = useDarkMode();
  const navigate = useNavigate();
  const {canSubscribe} = useRole();

  return (
    <Box
      sx={{
        backgroundColor: mode.settings.cardBackgroundColor,
        borderRadius: 1,
        padding: '20px',
      }}>
      {profil && (
        <Stack gap={5}>
          <Typography variant={'subtitle7'} color={mode.settings.textColor3}>
            Informations générales
          </Typography>
          <Stack direction={'row'} gap={5} flexWrap={"wrap"} justifyContent={{xs : 'center', md : 'center', lg : 'flex-start'}}>
            <Avatar
              variant="square"
              style={{height: 200, width: 200}}
              src={`${axios.defaults.apiBaseURL}/${profil.image}`}
            />
            <Stack
              style={{marginLeft: '20px'}}
              justifyContent={'space-between'}

            >
              <Typography variant={'body2'} color={mode.settings.textColor3}>
                  {profil.first_name} {profil.last_name}
              </Typography>
              <InformationBox
                icon={'birthday'}
                alt={'Date de naissance'}
                label={'Date de naissance'}
                info={profil.birthdate ? moment(profil.birthdate * 1000).format('DD MMM YYYY') : ''}
              />
              <InformationBox
                icon={'phone'}
                alt={'Téléphone'}
                label={'Téléphone'}
                info={formatPhoneNumber(profil.phoneNumber ?? '')}
              />
              <InformationBox
                icon={'mail'}
                alt={'Email'}
                label={'Email'}
                info={profil.email}
              />
              <InformationBox
                icon={'location'}
                alt={'Adresse Postale'}
                label={'Adresse Postale'}
                info={profil.address}
                info2={profil.postalCode + " " + profil.city}
              />
            {/*<InformationBox*/}
            {/*    icon={'location'}*/}
            {/*    alt={'Ville'}*/}
            {/*    label={'Ville'}*/}
            {/*    info={profil.city}*/}
            {/*/>*/}
            </Stack>
          </Stack>
          <Stack direction={'row'} sx={{alignSelf: 'flex-end'}} flexWrap={"wrap"} gap={2} justifyContent={"center"}>
            {canSubscribe && (
              <Button
                className="btn-low"
                sx={{backgroundColor : mode.settings.inputBackgroundColor}}
                onClick={() => navigate('/user-subscription')}>
                <img
                  src={'/assets/icon/abonnement.png'}
                  alt={'Voir mon abonnement'}
                  style={{marginRight: '10px'}}
                />
                <Typography
                  variant={'subtitle3'}
                  component="span"
                  style={{color: mode.settings.textColor3}}>
                  Voir mon abonnement
                </Typography>
              </Button>
            )}
            <Button className="btn" onClick={() => setUpdateMode(true)}>
              <img
                src={'/assets/icon/edit-.png'}
                alt={'Modifier mon profile'}
                style={{marginRight: '10px'}}
              />
              <Typography variant={'subtitle3'} component="span">
                Modifier mon profil
              </Typography>
            </Button>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default ViewProfile;
